import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/ui.json';
import fr from './locales/fr/ui.json';

// English + French, like the rest of Peerception. Every new UI string must be added
// to BOTH locale files (project i18n rule).
// English is the DEFAULT/priority display language; French is available via the
// in-app language toggle (it is NOT auto-selected from the browser locale).
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
